import React from "react";

type CmpPropsType = {
    valueCents: number,
    allowZero: boolean,
    textIfEmpty?: string,
    className?: string,
    onClick?: ()=>void,
}

// @ts-ignore
const IntlNumberFormat = new Intl.NumberFormat({ style: 'decimal', useGrouping: true, maximumSignificantDigits: 2 });



export function formatValueCents(valueCents:number, textIfEmpty:string = '', allowZero:boolean = false):string {
    const fallbackText:string = textIfEmpty || '';
    return Number.isInteger(valueCents) && (allowZero || valueCents !== 0) ? IntlNumberFormat.format(valueCents / 100.0) : fallbackText;
}


export default function NumberDisplay(props:CmpPropsType) {
    return <span className={props.className || 'number-display'} onClick={props.onClick}>{formatValueCents(props.valueCents, props.textIfEmpty)}</span>;
}


NumberDisplay.formatValueCents = formatValueCents;
